import { useHistory, useParams } from 'react-router-dom'
import { useFestivalLineupQuery, useFilmFeaturePlaylistQuery } from '@mwxltd/flix-api-client'
import { useNextLineupFilm } from '@flix/common/domain/festival/hooks/useNextLineupFilm'
import LoadingGrid from '../../../components/layout/Loading/LoadingGrid'
import VideoPlayer from '../../../components/video/VideoPlayer/VideoPlayer'
import ErrorPage from '../../../containers/errors/ErrorPage/ErrorPage'

export const FestivalPlayerPage = () => {
  const history = useHistory()
  const { festivalId, filmSlug } = useParams()

  const {
    loading,
    error,
    data: { film, playlist = [] },
    refreshUrl,
  } = useFilmFeaturePlaylistQuery({ slug: filmSlug, festivalId })

  const { data: festival } = useFestivalLineupQuery()

  const nextFilm = useNextLineupFilm(festival?.films?.find((f) => f.slug === filmSlug))

  if (loading) {
    return <LoadingGrid />
  }
  if (error) {
    return <ErrorPage error={error} />
  }
  return (
    <VideoPlayer
      festivalId={festivalId}
      nextFilm={nextFilm}
      playlist={playlist}
      onRequestRefreshUrl={refreshUrl}
      onRequestClose={() => history.goBack()}
      errorMetadata={{ film: { slug: filmSlug } }}
      filmSlug={filmSlug}
      filmId={film?.id}
    />
  )
}
